import React from 'react';

import styled from 'styled-components';

import { unlimitedKmImage } from 'assets/images/icons/additionalServices';

const UnlimitedKmIcon = () => <Icon src={unlimitedKmImage} />;

const Icon = styled.img`
	height: 60px;
	width: 60px;
`;

export default UnlimitedKmIcon;
